(function ($) {
  'use strict';

  /**
   * jQuery plugin: scroll element into view.
   */
  $.fn.scrollToElement = function(offset, duration) {
      var scrollTop;
      if ($(this).length) {
          scrollTop = $(this).closest(':visible').offset().top;
          $('html, body').animate({scrollTop: scrollTop - (offset || 0)}, duration || 500);
      }
      return this;
  };

  Drupal.behaviors.gallery = {
    attach: function() {
      $('nav.ankermenu:not(.initialized)').each(function() {
        var $nav = $(this).addClass('initialized'),
            $entries = $nav.find('ul');

        $('.ankermenuentry').each(function() {
          var $target = $(this);

          $('<li></li>')
          .appendTo($entries)
          .text($target.find('.label').text())
          .on('click', function() {
            $target.scrollToElement(150);
          });
        });
      })
    },
  };
}(jQuery));
